// @flow

import * as React from 'react';

import Skeleton from '@ta/styleguide.skeleton';
import { NavigableListItem } from '@ta/list.navigable-list';

import styles from './LoadingResult.less';
import BasicResult from './BasicResult';

/**
 * Result used as placeholder in typeahead result list
 */
const LoadingResult = () => (
  <NavigableListItem>
    <Skeleton>
      <div className={styles.invisible}>
        {/* not great, but no easy/elegant way to dinamically
          set the height (or guess the height of the to-be-loaded result */}
        <BasicResult title="Loading" iconName="globe-world" subtitle="Loading" active />
      </div>
    </Skeleton>
  </NavigableListItem>
);

export default LoadingResult;
